<script setup lang="ts">
import { computed } from 'vue';
import { useOnboardingPopup } from '#layers/access/public';

const { state, toggle, doneCount, totalCount } = useOnboardingPopup();

const visible = computed(() => state.value.status === 'active');
const open = computed(() => !state.value.collapsed);
const undoneCount = computed(() => totalCount - doneCount.value);
</script>

<template>
	<DTooltip v-if="visible" :text="$t('onboarding_popup.heading')">
		<DChip
			:show="undoneCount > 0"
			color="primary"
		>
			<DButton
				size="sm"
				variant="ghost"
				color="neutral"
				icon="lucide:compass"
				:pressed="open"
				:aria-pressed="open"
				:aria-label="$t('onboarding_popup.heading')"
				@click="toggle"
			/>
		</DChip>
	</DTooltip>
</template>
